import { render, staticRenderFns } from "./BackTop.vue?vue&type=template&id=1d8b7d2f&scoped=true"
var script = {}
import style0 from "./BackTop.vue?vue&type=style&index=0&id=1d8b7d2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b7d2f",
  null
  
)

export default component.exports